"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const recharts_1 = require("recharts");
require("./index.scss");
const DashboardNoDataInfo_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderDashboard/DashboardNoDataInfo"));
const dayjs_1 = __importDefault(require("dayjs"));
const DashboardRoyaltiesGraph = ({ data }) => (react_1.default.createElement("div", { className: 'dashboard-content-card royalties-graph' },
    react_1.default.createElement("div", { className: 'royalties-graph-title' },
        react_1.default.createElement("div", null, "Your amount paid over time"),
        react_1.default.createElement("div", null, "Last 6 months")),
    (data === null || data === void 0 ? void 0 : data.length) ? (react_1.default.createElement("div", { className: 'royalties-graph-area' },
        react_1.default.createElement(recharts_1.ResponsiveContainer, { width: '100%', aspect: 2.5 },
            react_1.default.createElement(recharts_1.LineChart, { data: data, margin: { top: 30, right: 40, left: 40, bottom: 10 } },
                react_1.default.createElement(recharts_1.CartesianGrid, { stroke: "#ccc" }),
                react_1.default.createElement(recharts_1.Line, { name: 'Amount Paid', type: 'linear', stroke: '#0e52b7', strokeWidth: 2, dot: { fill: '#0e52b7', fillOpacity: 1, z: 999 }, dataKey: "amount" }),
                react_1.default.createElement(recharts_1.XAxis, { dataKey: 'distributionId', tickFormatter: (val) => (0, dayjs_1.default)(val, 'YYYY-MM').format("MMM [']YY") }),
                react_1.default.createElement(recharts_1.YAxis, { tickFormatter: (val) => Intl.NumberFormat('en-US', {
                        notation: 'compact',
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 1,
                    }).format(val) }),
                react_1.default.createElement(recharts_1.Tooltip, { labelFormatter: (val) => (0, dayjs_1.default)(val, 'YYYY-MM').format('MMM YYYY'), formatter: (otherVal) => otherVal.toLocaleString('en-US', {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }) }))))) : (react_1.default.createElement(DashboardNoDataInfo_1.default, { type: 'royalty data' }))));
exports.default = DashboardRoyaltiesGraph;
